import React from "react";

const AuthenticationButton = ({ buttonPrompt, onClickFunction }) => {
  return (
    <button
      className="mt-10 mb-5 bg-neutral-400 hover:bg-neutral-500 active:bg-neutral-600 px-5 py-2 rounded-lg text-xl text-white
      w-full sm:w-4/5
      "
      onClick={onClickFunction}
    >
      {buttonPrompt}
    </button>
  );
};

export default AuthenticationButton;
